import { atom } from 'recoil';

export const OpenSideBarState = atom({
    key: 'OpenSideBarState',
    default: false
});